var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vt-lock-toggle",attrs:{"tabindex":"-1"},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('i',{class:_vm.classIcon,attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }